<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m">
					{{ $t('rtr_personal-how-online_shopping.title1') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-how-online_shopping.text1') }}<br />
					{{ $t('rtr_personal-how-online_shopping.text2') }}
				</p>

				<div class="button_area">
					<button
						class="button_bg_red mr_10"
						@click="$router.push({ name: 'auth-register' })"
					>
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>

		<section class="content_area bg_gray">
			<p class="title_m">
				{{ $t('rtr_personal-how-online_shopping.text3') }}<br />
				<span class="fc_red">{{
					$t('rtr_personal-how-online_shopping.text4')
				}}</span
				>{{ $t('rtr_personal-how-online_shopping.text5')
				}}{{ $t('rtr_personal-how-online_shopping.text6') }}
			</p>
			<div>
				<swiper
					:slides-per-view="1"
					:pagination="true"
					:navigation="true"
					:modules="modules"
				>
					<swiper-slide>
						<div class="slide_item">
							<div class="icon">
								<img
									src="@/assets/images/sub/m_online_shopping_icon_01.png"
									alt=""
								/>
							</div>
							<p class="body_m">
								{{ $t('rtr_personal-how-online_shopping.text7') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text8') }}
							</p>
						</div>
					</swiper-slide>
					<swiper-slide
						><div class="slide_item">
							<div class="icon">
								<img
									src="@/assets/images/sub/m_online_shopping_icon_02.png"
									alt=""
								/>
							</div>
							<p class="body_m">
								{{ $t('rtr_personal-how-online_shopping.text9') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text10') }}
							</p>
						</div></swiper-slide
					>
					<swiper-slide>
						<div class="slide_item">
							<div class="icon">
								<img
									src="@/assets/images/sub/m_online_shopping_icon_03.png"
									alt=""
								/>
							</div>
							<p class="body_m">
								{{ $t('rtr_personal-how-online_shopping.text11') }}<br />
								{{ $t('rtr_personal-how-online_shopping.text12') }}
							</p>
						</div>
					</swiper-slide>
				</swiper>
			</div>
		</section>

		<section class="content_area">
			<div class="detail_area">
				<div class="detail">
					<h2 class="headline_s">
						{{ $t('rtr_personal-how-online_shopping.title2') }}<br />
						{{ $t('rtr_personal-how-online_shopping.title3') }}
					</h2>
					<p class="body_m mb_60">
						{{ $t('rtr_personal-how-online_shopping.text13') }}<br />
						{{ $t('rtr_personal-how-online_shopping.text14') }}<br />
						{{ $t('rtr_personal-how-online_shopping.text15') }}<br />
						{{ $t('rtr_personal-how-online_shopping.text16') }}
					</p>
				</div>
			</div>
			<div class="img_area">
				<img src="@/assets/images/sub/online_shopping_02.png" alt="" />
			</div>
		</section>

		<section class="content_area">
			<div class="detail_area">
				<div class="detail">
					<h2 class="headline_s">
						{{ $t('rtr_personal-how-online_shopping.title4') }}
						{{ $t('rtr_personal-how-online_shopping.title5') }}
					</h2>
					<p class="body_m mb_60">
						{{ $t('rtr_personal-how-online_shopping.text17') }}<br />
						{{ $t('rtr_personal-how-online_shopping.text18') }}<br />
						{{ $t('rtr_personal-how-online_shopping.text19') }}
					</p>
				</div>
			</div>
			<div class="img_area">
				<img src="@/assets/images/sub/online_shopping_03.png" alt="" />
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
import { Pagination, Navigation } from 'swiper';
export default {
	name: 'OnlineShopping.m',
	setup() {
		return {
			modules: [Pagination, Navigation],
		};
	},
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
